var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ControllerWrapper } from '../../controller-wrapper';
import { Counter } from '../modules/counter';
import { SelectController } from './modules';
import { checkEqual } from 'common/helpers/checkEqual';
export var Select = function (_a) {
    var label = _a.label, value = _a.value, hidden = _a.hidden, options = _a.options, isError = _a.isError, multiple = _a.multiple, isRequired = _a.isRequired, helperText = _a.helperText, showCounter = _a.showCounter, maxSelectCount = _a.maxSelectCount, labelAdditional = _a.labelAdditional, wrapperClassName = _a.wrapperClassName, useValuesSelector = _a.useValuesSelector, useOptionsSelector = _a.useOptionsSelector, rest = __rest(_a, ["label", "value", "hidden", "options", "isError", "multiple", "isRequired", "helperText", "showCounter", "maxSelectCount", "labelAdditional", "wrapperClassName", "useValuesSelector", "useOptionsSelector"]);
    var isValueSelector = typeof value === 'function';
    var isOptionsSelector = typeof options === 'function';
    var selectValue = isValueSelector ? useValuesSelector(value, checkEqual) : value;
    var selectOptions = isOptionsSelector ? useOptionsSelector(options, checkEqual) : options;
    var tagsCounterView = null;
    if (multiple && showCounter && maxSelectCount) {
        tagsCounterView = _jsx(Counter, { maxCount: maxSelectCount, currentCount: (selectValue === null || selectValue === void 0 ? void 0 : selectValue.length) || 0 });
    }
    return (_jsx(ControllerWrapper, __assign({ wrapperClassName: wrapperClassName, name: rest.name, label: label, helperText: helperText, isRequired: isRequired, isError: isError, labelAdditional: (labelAdditional || tagsCounterView) && (_jsxs(_Fragment, { children: [labelAdditional, tagsCounterView] })), hidden: hidden }, { children: _jsx(SelectController, __assign({ isError: isError, value: selectValue, multiple: multiple, maxSelectCount: maxSelectCount, options: selectOptions }, rest)) })));
};
